// @ts-nocheck
import { populate } from 'populate';
import type { Container } from 'pixi.js';

const raw = {
  width: 664,
  height: 667,
  x: 0,
  y: 0,
  list: [
    {
      id: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      type: 'Container',
      runtimeType: null,
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: null,
      stateByName: {}
    },
    {
      id: 'ad97435f-8e3d-4b08-a9cf-b78c84f34bfa',
      type: 'Sprite',
      runtimeType: null,
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Share_Diorama_Post',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      stateByName: {},
      data: undefined
    },
    {
      id: '6d58ada5-9273-4cba-a8f1-04284e9daf99',
      type: 'Container',
      runtimeType: null,
      name: 'dioramaSlot',
      className: '',
      x: 0,
      y: 183,
      scale: {
        x: 0.83,
        y: 0.83
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      stateByName: {},
      data: undefined
    },
    {
      id: 'f7d8e07b-88c1-4708-8ef1-a72c98c4e52d',
      type: 'Sprite',
      runtimeType: null,
      name: '',
      className: '',
      x: 0,
      y: 223,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Hexa_Logo',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      stateByName: {},
      data: undefined
    }
  ],
  version: '1.0.0',
  stateNames: [],
  animations: []
} as const;

export class DioramaShareLayout {
  static raw = raw;
  root: Container;
  dioramaSlot: Container;

  mInternalTypes: {
    Raw: typeof raw;
    StateName: never;
    ModelByName: {
      root: typeof raw['list'][0];
      dioramaSlot: typeof raw['list'][2];
    };
  };

  constructor() {
    populate(this, raw);
  }
}
